import { render, staticRenderFns } from "./PortalSendModal.vue?vue&type=template&id=2e88c598&scoped=true"
import script from "./PortalSendModal.vue?vue&type=script&lang=ts"
export * from "./PortalSendModal.vue?vue&type=script&lang=ts"
import style0 from "./PortalSendModal.vue?vue&type=style&index=0&id=2e88c598&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e88c598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e88c598')) {
      api.createRecord('2e88c598', component.options)
    } else {
      api.reload('2e88c598', component.options)
    }
    module.hot.accept("./PortalSendModal.vue?vue&type=template&id=2e88c598&scoped=true", function () {
      api.rerender('2e88c598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/client-portal/PortalSendModal.vue"
export default component.exports